module.exports = __webpack_public_path__ + "fonts/TheMix_cls_TT3_.172e8d0d.woff";